module.exports = __webpack_public_path__ + "static/media/ebook-2.1a2c31d5.png";